import React from 'react'
import No from '../../Assets/Images/Login/no.svg'
import './genericModal.css'
import check from '../../Assets/Images/Login/check.png'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'

function GenericModal({
  setIsOpen,
  text,
  setConfirm,
  mostrarButtons = true,
  mostrarImg = false,
  hideCheck = false,
  showCaution = false,
  text2 = '',
  closeLessPadding = false,
  gapTexts = false,
}) {
  return (
    <>
      <div
        className={
          showCaution && !text2
            ? 'modal-box-generic-modal-caution'
            : !showCaution && !text2
            ? 'modal-box-generic-modal'
            : 'modal-box-generic-modal-caution2'
        }
        data-testid="container-generic-modal">
        <div
          className={
            showCaution || closeLessPadding
              ? 'closing-button-less-padding'
              : 'generic-closing-button modal-client'
          }>
          <img
            src={No}
            onClick={() => setIsOpen(false)}
            alt="close"
            data-testid="btn-close-generic-modal"
          />
        </div>
        <div className="modal-content-text" data-testid="container-modal-text">
          {hideCheck ? null : (
            <img
              style={{ height: '30px', marginBottom: '19px' }}
              src={check}
              alt="check"
              data-testid="icon-check-modal"
            />
          )}
          {showCaution ? (
            <ExclamationTriangleFill
              style={{
                fontSize: '40px',
                color: '#FF2A40',
                marginBottom: '19px',
              }}
              data-testid="icon-caution-modal"
            />
          ) : null}
          <h2 className="text1" data-testid="text-modal-primary">
            {text}
          </h2>
          {gapTexts ? <br /> : null}
          {text2 !== '' ? (
            <h2 data-testid="text-modal-secondary">{text2}</h2>
          ) : null}
        </div>
        <div
          className="modal-content-buttons"
          style={{ display: mostrarButtons ? 'flex' : 'none' }}
          data-testid="container-modal-buttons">
          <button
            onClick={() => setConfirm(true)}
            data-testid="btn-confirm-modal">
            Si
          </button>
          <button
            onClick={() => setIsOpen(false)}
            data-testid="btn-cancel-modal">
            No
          </button>
        </div>
      </div>
    </>
  )
}

export default GenericModal
